import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Table,
  TableColumn,
  Input,
  Popover,
  Tag,
  Dialog,
  Tooltip,
  Pagination,
  Select,
  Option,
  Tabs,
  TabPane,
  Autocomplete,
  Col,
  Row,
  Form,
  FormItem,
  Message,
  MessageBox,
  Cascader,
  DatePicker,
  Radio,
  RadioGroup,
  Loading,
  Upload,
  Scrollbar,
  Container,
  Aside,
  Header,
  Main,
  Submenu,
  MenuItem,
  Checkbox,
  Progress,
  CheckboxGroup,
  MenuItemGroup,
  RadioButton,
  Tree,
  OptionGroup,
  Transfer,
  Carousel,
  CarouselItem,
  InputNumber,
  Card,
  Image,
  Slider,
  Switch,
  Steps,
  Step,
  Timeline,
  TimelineItem,
  Divider,
  Drawer,
  Menu,
  Link,
  Rate,
  ColorPicker,
  Popconfirm,
  PageHeader
} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

export default {
  install(Vue, option) {
    Vue.prototype.$ELEMENT = Object.assign({ size: 'mini', zIndex: 3000 }, option)
    Vue.use(Button)
    Vue.use(ButtonGroup)
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Input)
    Vue.use(Popover)
    Vue.use(Tag)
    Vue.use(Dialog)
    Vue.use(Tooltip)
    Vue.use(Pagination)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Autocomplete)
    Vue.use(Col)
    Vue.use(Row)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Cascader)
    Vue.use(DatePicker)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(Upload)
    Vue.use(Scrollbar)
    Vue.use(Loading.directive)
    Vue.use(Container)
    Vue.use(Aside)
    Vue.use(Header)
    Vue.use(Main)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(MenuItemGroup)
    Vue.use(Progress)
    Vue.use(RadioButton)
    Vue.use(Tree)
    Vue.use(OptionGroup)
    Vue.use(Transfer)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(InputNumber)
    Vue.use(Card)
    Vue.use(Image)
    Vue.use(Slider)
    Vue.use(Switch)
    Vue.use(Steps)
    Vue.use(Step)
    Vue.use(Divider)
    Vue.use(Timeline)
    Vue.use(TimelineItem)
    Vue.use(Drawer)
    Vue.use(Menu)
    Vue.use(Link)
    Vue.use(Rate)
    Vue.use(ColorPicker)
    Vue.use(Popconfirm)
    Vue.use(PageHeader)
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$message = Message
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$msgbox = MessageBox

    Vue.component(CollapseTransition.name, CollapseTransition)
  }
}
